module.exports = __webpack_public_path__ + "static/media/izlozba (18).cd23f085.jpg";